module.exports = __webpack_public_path__ + "static/media/filled_end_bar_tall.8171a6b9.svg";